import { render, staticRenderFns } from "./view_blog_modal.vue?vue&type=template&id=647b876c&scoped=true"
import script from "./view_blog_modal.vue?vue&type=script&lang=js"
export * from "./view_blog_modal.vue?vue&type=script&lang=js"
import style0 from "./view_blog_modal.vue?vue&type=style&index=0&id=647b876c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_cache-loader@4.1.0_webpac_98d88fd53c1ad5e44e79d7b0571b6b60/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b876c",
  null
  
)

export default component.exports